import React from 'react';
import styles from '../Operations.module.css';

interface SO04Component extends React.FC {
  title?: string;
}

/**
 * SOCIRESPONSE - SOCI - Review Response Time (< 24 hours)
 * KPI information component
 */
const SO04: SO04Component = () => {
  return (
    <div className={styles.container}>
      <div className={styles.sectionTitle}>
        Metric Description
      </div>

      <div className={styles.sectionContent}>
        Shows how your store ranks among Google, Facebook and Yelp.
      </div>

      <div className={styles.sectionTitle}>
        Supporting Details
      </div>

      <div className={styles.sectionContent}>
        Maintain a star rating between 4.5-4.7 stars.<br/><br/>
        Answer all reviews and engagements &lt; 24 hours.
      </div>

      <div className={styles.sectionTitle}>
        Goal
      </div>

      <div className={styles.sectionContent}>
        Answer all reviews &lt;24 hours.
      </div>

      <div className={styles.sectionTitle}>
        Take Action
      </div>

      <div className={styles.sectionContent}>
        Sign-up and Questions:
        <ol>
          <li>
            Sign-up at no charge for the platform, visit{' '}
            <a
              href="https://www.soci.ai/acehardware/"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.link}>
              https://www.soci.ai/acehardware/
            </a>
          </li>
          <li>Questions? Email: support@meetsoci.com</li>
        </ol>
      </div>
    </div>
  );
};

SO04.title = 'SOCi - Customer Review Response Time (Hours)';
export default SO04;

